import { Button, CircularProgress, Typography } from '@mui/material'
import firebaseUtil from 'firebaseUtil'
import React, { useEffect, useState } from 'react'
import { usePerfil } from 'useAuth'

export default function SwitchDB({ closeMenu }) {
    const [loading, setLoading] = useState(true)
    const [online, setOnline] = useState(true)
    const perfil = usePerfil();
    let networkDisabled = firebaseUtil.networkDisabled
    useEffect(() => {
        setOnline(!networkDisabled)
        setLoading(false)

    }, [networkDisabled])
    const toggleConection = () => {
        console.log('toggleConection')
        if (networkDisabled) {
            firebaseUtil.enableNetwork()
        } else {

            firebaseUtil.disableNetwork()
        }
        if (closeMenu) closeMenu()
    }
    if (!perfil) {
        return ""
    }
    return (
        // <div style={{ backgroundColor: online ? "#0F0" : "#f00", textAlign: 'center', padding: 5 }}>
        <div style={{ textAlign: 'center', padding: 5 }}>
            <Button onClick={toggleConection} variant='contained' disabled={loading} color='secondary'>{loading ? <CircularProgress /> : online ? "Alterar para OFFLINE" : "Alterar para ONLINE"}</Button>
            {online ? <Typography sx={{ alignSelf: "center", fontSize: 14, color: "#fff" }}>Banco de Dados Online</Typography> : <Typography sx={{ alignSelf: "center", fontSize: 14 }}>Banco de Dados OFFLINE</Typography>}
        </div>
    )
}
